<template>
  <div>
    <h1>Històric d'incidències de les teves subcategories</h1>
    <ManagerTicketsTable :table_rows="this.groups_history_tickets"
    :priorities="priorities" :states="states" v-if="this.groups_history_tickets" :other_filters="['Suprimir duplicades o descartades']"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ManagerTicketsTable from '@/components/ManagerTicketsTable'

export default {
  components: {
    ManagerTicketsTable
  },
  computed: {
    ...mapGetters({
      groups_history_tickets: 'managerGroupsHistoryTickets'
    }),
    states () {
      return this.$store.state.states.map(function (obj) {
        return obj.displayname
      })
    },
    priorities () {
      return this.$store.state.priorities.map(function (obj) {
        return obj.descripcio
      })
    }
  },
  created () {
    this.$store.dispatch('fetchManagerGroupsHistoryTickets')
    this.$store.dispatch('fetchStates')
    this.$store.dispatch('fetchPrioritats')
  }
}
</script>

<style module>
</style>
